<template>
  <svg
    id="flag-icons-se"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
    :height="height"
  >
    <path fill="#0035ad" d="M0 0h808v600H0z" />
    <path fill="#ffce00" d="M0 0h370v600H0z" />
    <path fill="#007229" d="M0 0h314v600H0z" />
    <path fill="#dc241f" d="M0 0h258v600H0z" />
    <path
      fill="#0035ad"
      d="M314 108a192 192 0 0 0 0 384l16-16-16-16a160 160 0 0 1 0-3 20l16-16-16-16z"
    />
    <path
      fill="none"
      stroke="#dc241f"
      stroke-width="32"
      d="M314 124a176 176 0 0 1 0 352"
    />
  </svg>
</template>

<script>
export default {
  name: 'SeFlag',
  props: {
    height: {
      type: String,
      default: '20px'
    }
  }
}
</script>
